import { render } from "./GeneratePresentation.vue?vue&type=template&id=04129f48"
import script from "./GeneratePresentation.vue?vue&type=script&lang=js"
export * from "./GeneratePresentation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/GeneratePresentation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04129f48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04129f48', __exports__)) {
    api.reload('04129f48', __exports__)
  }
  
  module.hot.accept("./GeneratePresentation.vue?vue&type=template&id=04129f48", () => {
    api.rerender('04129f48', render)
  })

}


export default __exports__